import { About } from "./components/About";
import { Blog } from "./components/Blog";
import  Contact  from "./components/Contact";
import { Faqs } from "./components/Faqs";
import { Home } from "./components/Home";
import { KeyAreas } from "./components/KeyAreas";
import { PageNotFound } from "./components/PageNotFound";
//import { Projects } from "./components/Projects";
import { Services } from "./components/Services";

const AppRoutes = [
  { index: true, element: <Home /> },
  { path: '/aboutus', element: <About /> },
  { path: '/blog', element: <Blog /> },
  { path: '/contactus', element: <Contact /> },
  { path: '/faqs', element: <Faqs /> },
  { path: '*', element: <PageNotFound /> },
  //{ path: '/projects', element: <Projects /> },
    { path: '/services', element: <Services /> },
  { path: '/keyareas', element: <KeyAreas /> }
];

export default AppRoutes;
